import { render } from "./ApiPdfLink.vue?vue&type=template&id=1bc40590&scoped=true"
import script from "./ApiPdfLink.vue?vue&type=script&lang=js"
export * from "./ApiPdfLink.vue?vue&type=script&lang=js"

import "./ApiPdfLink.vue?vue&type=style&index=0&id=1bc40590&scoped=true&lang=css"

import exportComponent from "/Users/ions-alpha/Documents/IONS-project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc40590"]])

export default __exports__